const ANSWER_TYPE = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE'
};

const REDIRECT_URI = `${window.location.origin}`;

const SURVEYS = {
  HOLLAND: 'cong-cu-holland',
  SKILLS: 'cong-cu-liet-ke-ky-nang',
  MBTI: 'cong-cu-mbti',
  WORKING_VALUE: 'cong-cu-gia-tri-song',
  LIFE_CYCLE: 'cong-cu-vong-tron-cuoc-doi'
};

const PORTFOLIO = {
  DRAFT: 'draft',
  PUBLISH: 'publish'
};

const SMART = [
  { name: 'Specific', sign: 'S', subSign: 'G', color: '#0d83b1', text: '' },
  { name: 'Measurable', sign: 'M', subSign: 'O', color: '#08adae', text: '' },
  { name: 'Attainable', sign: 'A', subSign: 'A', color: '#08aa7c', text: '' },
  { name: 'Relevant', sign: 'R', subSign: 'L', color: '#59bb19', text: '' },
  { name: 'Time-Bound', sign: 'T', subSign: 'S', color: '#b6c524', text: '' },
];

const GROW = [
  { name: 'Goals', sign: 'G', color: '#5b9bd5', text: 'What do you want?' },
  { name: 'Reality', sign: 'R', color: '#54c9b8', text: 'Where are you now?' },
  { name: 'Options', sign: 'O', color: '#48c064', text: 'What could you do?' },
  { name: 'Wrap-up', sign: 'W', color: '#71ad47', text: 'What will you do?' },
];

export { ANSWER_TYPE, REDIRECT_URI, SURVEYS, PORTFOLIO, SMART, GROW };
